import React, { FC } from 'react';
import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';

export const EmptyDataDefault: FC = () => {
  return (
    <Box fullWidth justifyContent={'center'}>
      <Text id={'tableIsEmpty'}>Нет данных в таблице</Text>
    </Box>
  );
};
